<wvr-alert-component
  [alertType]="alertType"
  [themeVariant]="themeVariant"
  [closeable]="closeable"
  [closeTimer]="closeTimer">
  <ng-content select="template" ngProjectAs="template"></ng-content>
</wvr-alert-component>
